import { useRef } from "react";
import { Link } from "react-router-dom";
import { ChevronLeft, ChevronRight, ArrowRight } from "lucide-react";
import { MovieCard } from "@/components/MovieCard";

export function Row({ title, note, items, viewAll, testid, empty }) {
  const ref = useRef(null);
  const scroll = (d) => ref.current?.scrollBy({ left: d * ref.current.clientWidth * 0.8, behavior: "smooth" });
  return (
    <section data-testid={testid} className="fade-up py-6">
      <div className="mb-4 flex items-end justify-between gap-4 px-4 sm:px-6 lg:px-12">
        <div>
          <h2 className="font-display text-2xl sm:text-3xl text-slate-50">{title}</h2>
          {note && <p className="mt-0.5 text-xs text-slate-500 sm:text-sm">{note}</p>}
        </div>
        <div className="flex items-center gap-2">
          {viewAll && items?.length > 0 && (
            <Link to={viewAll} data-testid={`${testid}-view-all`} className="flex items-center gap-1 text-xs font-semibold uppercase tracking-wider text-amber-400 hover:text-amber-300">
              View all <ArrowRight className="h-3.5 w-3.5" />
            </Link>
          )}
          <button aria-label="Scroll left" onClick={() => scroll(-1)} className="hidden sm:flex h-8 w-8 items-center justify-center rounded-full border border-white/10 hover:border-amber-400 hover:text-amber-400 transition-colors"><ChevronLeft className="h-4 w-4" /></button>
          <button aria-label="Scroll right" onClick={() => scroll(1)} className="hidden sm:flex h-8 w-8 items-center justify-center rounded-full border border-white/10 hover:border-amber-400 hover:text-amber-400 transition-colors"><ChevronRight className="h-4 w-4" /></button>
        </div>
      </div>
      {items?.length ? (
        <div ref={ref} className="no-scrollbar flex snap-x snap-mandatory gap-4 overflow-x-auto px-4 pb-2 sm:px-6 lg:px-12">
          {items.map((t) => <MovieCard key={t.id} t={t} />)}
        </div>
      ) : (
        <p className="mx-4 rounded-xl border border-dashed border-white/10 p-6 text-sm text-slate-500 sm:mx-6 lg:mx-12">{empty || "Nothing here yet — check back soon."}</p>
      )}
    </section>
  );
}
